export const visit = (vm, at) => {
at({ "fi": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} / {{totalBytes}}" }, "fileSizeLimit": "Tiedosto ei voi olla suurempi kuin {{size}}", "screenCapture": "N\xE4yt\xF6n tallentaminen" } } });
};